import React, { Component } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { routes } from "./paths";
import {
  Dashboard,
  Notification,
  Notification2,
  Login,  
  OrderDetailsInProgress,
  NewOrderDetails,
  OrderDetailsShipment,
  OrderDetaisDelivery,
  PackagingSlip,
  PastOrders,
  PastOrderDetails,
  ChangePassword,
  
} from "../screens"; 
import {ServicePackagingSlip} from "../screens/Print/PackagingSlip/ServicePackagingSlip";

const AuthRoute = ({ children }) => {
  const authenticated = localStorage.getItem("isAuthenticated");
  if (authenticated === "false") {
    return <Navigate to="/" />;
  }
  return children;
};

class WebRouter extends Component {
  render() {
    return (
      <>
        <Routes>
          <Route
            exact
            path={routes.dashboard}
            element={
              <AuthRoute>
                <Dashboard />
              </AuthRoute>
            }
          />
          <Route exact path={routes.login} element={<Login />} />
          <Route exact path={routes.changePassword} element={<ChangePassword />} />
          <Route
            path={routes.notification}
            element={
              <AuthRoute>
                <Notification />
              </AuthRoute>
            }
          />
          <Route
            path={routes.notification2}
            element={
              <AuthRoute>
                <Notification2 />
              </AuthRoute>
            }
          />
          <Route
            path={routes.orderDetailsShipment}
            element={
              <AuthRoute>
                <OrderDetailsShipment />
              </AuthRoute>
            }
          />
          <Route
            path={routes.orderDetailsInProgress}
            element={
              <AuthRoute>
                <OrderDetailsInProgress />
              </AuthRoute>
            }
          />
          <Route
            path={routes.newOrderDetails}
            element={
              <AuthRoute>
                <NewOrderDetails />
              </AuthRoute>
            }
          />
          <Route
            path={routes.deliveryOrderDetails}
            element={
              <AuthRoute>
                <OrderDetaisDelivery />
              </AuthRoute>
            }
          />
          <Route
            path={routes.printPackagingSlip}
            element={
              <AuthRoute>
                <PackagingSlip />
              </AuthRoute>
            }
          />
          <Route
            path={routes.pastOrders}
            element={
              <AuthRoute>
                <PastOrders />
              </AuthRoute>
            }
          />
          <Route
            path={routes.pastOrderDetails}
            element={
              <AuthRoute>
                <PastOrderDetails />
              </AuthRoute>
            }
          />
          <Route
            path={routes.servicePackagingSlips}
            element={
                 <ServicePackagingSlip />
              
            }
          />
        </Routes>
      </>
    );
  }
}

export default WebRouter;
